import React from 'react';

import mapboxgl from 'mapbox-gl';

import CrewMapControlsWrapper from './CrewMapControlsWrapper';
import { MAP_CONSTANTS } from './mapConstants';

export function setupTerrain(mapInstance: mapboxgl.Map, mapRef: React.RefObject<mapboxgl.Map | null>): void {
  mapInstance.addSource('mapbox-dem', {
    type: 'raster-dem',
    url: 'mapbox://mapbox.terrain-rgb',
    tileSize: 512,
    maxzoom: MAP_CONSTANTS.TERRAIN_MAXZOOM
  });

  mapInstance.setTerrain({
    source: 'mapbox-dem',
    exaggeration: MAP_CONSTANTS.TERRAIN_EXAGGERATION
  });

  const currentZoom = mapInstance.getZoom();
  if (currentZoom < MAP_CONSTANTS.TERRAIN_MAXZOOM) {
    mapInstance.jumpTo({ zoom: MAP_CONSTANTS.TERRAIN_MAXZOOM });
    mapInstance.once('idle', () => {
      if (mapRef.current) {
        mapRef.current.jumpTo({ zoom: currentZoom });
      }
    });
  }
}

export function setupPathLayer(mapInstance: mapboxgl.Map): void {
  mapInstance.addSource('path', {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: []
      }
    }
  });

  mapInstance.addLayer({
    id: 'path-line',
    type: 'line',
    source: 'path',
    paint: {
      'line-color': MAP_CONSTANTS.PATH_LINE_COLOR,
      'line-width': MAP_CONSTANTS.PATH_LINE_WIDTH
    }
  });
}

export function setupAdditionalPathLayer(mapInstance: mapboxgl.Map, sourceId: string, color: string): void {
  if (mapInstance.getSource(sourceId)) return;

  mapInstance.addSource(sourceId, {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: []
      }
    }
  });

  mapInstance.addLayer({
    id: `${sourceId}-line`,
    type: 'line',
    source: sourceId,
    paint: {
      'line-color': color,
      'line-width': MAP_CONSTANTS.PATH_LINE_WIDTH
    }
  });
}

export function setupMapControls(mapInstance: mapboxgl.Map, customZoomControls: boolean, hideControls: boolean): void {
  if (hideControls) return;

  if (customZoomControls) {
    const crewControlsWrapper = new CrewMapControlsWrapper();
    mapInstance.addControl(crewControlsWrapper, 'top-left');
  } else {
    mapInstance.addControl(new mapboxgl.NavigationControl(), 'top-right');
    mapInstance.addControl(new mapboxgl.ScaleControl(), 'top-left');
  }
}
